import { getNbrLinkForFeatureArea } from "@/common/search-request"
import * as TYPE from "./_store/type"
export async function asyncData(store) {
    const { city, state } = this.featureArea
    if (!city || !state) {
        return 
    }
    try {
        let { data: { community = [], subdivision = [], area = [] } } =  await getNbrLinkForFeatureArea.call(this, {
            area: `${city}, ${state}`,
            siteId: this.page.siteId,
            searchCenter: this.page.searchCenter,
            areaType: 'city', 
            aggType: 'aggNbrLinks',
            aggSize: 200,
        }) 
        store[TYPE.UPDATE_COMMUNITY](community)
        store[TYPE.UPDATE_SUBDIVISION](subdivision)
        store[TYPE.UPDATE_AREA](area)
    } catch (error) {
        console.error(error)
    }
}
   
